export const POWER_BI_URL =
  "https://app.powerbi.com/view?r=eyJrIjoiYzRlNmYyM2QtNDE3NC00N2EyLThjZjktYzY4YjIxN2U5ODcwIiwidCI6ImIxNzBlMTE1LWRjM2QtNGU5Mi04NWJlLWU0YjMwMDljNWRjMiIsImMiOjl9";
export const PDF_URL = "/2_Manual de uso - Tablero SAHTOSO.pdf";
